import Backbone from 'backbone';
import $ from 'jquery';
import CsrImpersonationBarTemplate from './templates/_CsrImpersonationBar.hbs';
import LoggedInCustomerCsrImpersonationBarTemplate from './templates/_CsrImpersonationLoggedInCustomer.hbs';
import CsrImpersonationModal from './CsrImpersonationModal'
import userService from '../../services/CartUserService';
import config from '../../js/config';
import cookies from 'js-cookie';
import * as globalisation from '../../utilities/globalisation';

export default class CsrImpersonationBar extends Backbone.View {

  initialize($el) {
    this.$el = $el;
    this.model = {};
    userService.getUserInfo().then((userData) => {
      if (userData && userData.loggedIn) {
        this.model.csrFullName = userData.fullName;
        this.model.csrRole =  globalisation.pluraliseAndTranslate('csrImpersonation', 'csrRoleTitle');
        this.model.signInCustomer =  globalisation.pluraliseAndTranslate('csrImpersonation', 'customerSignInText');
        if (userData.permissions && userData.permissions.indexOf(config.csrImpersonation.csrPermission) > 0) {
          userService.getCustomerInfo().then(customerInfoResponse => {
            if (customerInfoResponse && customerInfoResponse.email) {
              this.model.customerFullname = customerInfoResponse.fullName;
              this.model.customerCheckoutText = globalisation.pluraliseAndTranslate('csrImpersonation', 'signedInAs');
              this.model.customerEmailAddress = customerInfoResponse.email;
              this.model.arrowAccountText =  globalisation.pluraliseAndTranslate('csrImpersonation', 'arrowAccount');
              this.$el.html(LoggedInCustomerCsrImpersonationBarTemplate(this.model));
              this.$elCustomerDetails = this.$el.find('.CsrImpersonationBar-csr-details')
              this.$elCustomerDetails.css('opacity', '0.7');
            }
            else {
              if (cookies.get(config.cookies.csrSignedInAsCustomer)) {
                cookies.remove(config.cookies.csrSignedInAsCustomer);
              }
              this.$el.html(CsrImpersonationBarTemplate(this.model));
            }
            this.$csrImpersonationForm = this.$el.find('.CsrImpersonation-form');
            this.$csrImpersonationForm.click((event) => {this.showCsrImpersonationForm(event)});
          });
        }
      }
    });
  }

  showCsrImpersonationForm(e) {
    e.preventDefault();
    let modal = new CsrImpersonationModal(this.$el, this.model);
    modal.open();
  }
}

export function createCsrImpersonationBar($parent) {
  $parent.find('#csrImpersonationBar').each((n, el) => {
    new CsrImpersonationBar($(el));
  });
}


// WEBPACK FOOTER //
// ./assets/components/CsrImpersonationBar/CsrImpersonationBar.js